import { render, staticRenderFns } from "./EmblemView.vue?vue&type=template&id=2a220448"
import script from "./EmblemView.vue?vue&type=script&lang=js"
export * from "./EmblemView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports